"use client"

import { useMemo } from "react"
import { useState, useEffect, useContext, useRef } from "react"
import { DataGrid } from "@mui/x-data-grid"
import {
  IconButton,
  Typography,
  Box,
  Paper,
  Button,
  Autocomplete,
  TextField,
  InputAdornment,
  Tooltip,
  Chip,
  alpha,
  Checkbox
} from "@mui/material"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import CustomPagination from "./CustomPagination"

// Icons
import VisibilityIcon from "@mui/icons-material/Visibility"
import ReplayIcon from "@mui/icons-material/Replay"
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf"
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
import SearchIcon from "@mui/icons-material/Search"
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff"
import CalendarTodayIcon from "@mui/icons-material/CalendarToday"
import LocationOnIcon from "@mui/icons-material/LocationOn"
import PersonIcon from "@mui/icons-material/Person"
import AttachMoneyIcon from "@mui/icons-material/AttachMoney"
import PointOfSaleIcon from "@mui/icons-material/PointOfSale"
import DeleteIcon from '@mui/icons-material/Delete';
import BarChartIcon from "@mui/icons-material/BarChart"
import TuneIcon from "@mui/icons-material/Tune"

import { ThemeProvider, createTheme } from "@mui/material/styles"
import { ErpContext } from "../../context/ErpContext.js"
import "./TablaVentasComponent.css"
import { GridFooterContainer, GridFooter } from "@mui/x-data-grid"

import dayjs from "dayjs"

import SpinnerLading from "../misc/SpinnerComponent.js"
import ModalViewTablaPresupuesto from "./ModalViewTablaPresupuesto.js"
import GraficasPresupuestosModal from "./graficas/graficas-presupuestos-modal.js"
import Swal from 'sweetalert2';


const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#5b5b5f",
    },
    secondary: {
      main: "rgb(244, 177, 14)",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: "none",
          boxShadow: "none",
          "&:hover": {
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 500,
        },
      },
    },
  },
})

export default function TablaVentas() {
  const {
    getMoneda,
    getTipoTransaccion,
    getUbicacion,
    ubicaciones,
    getNegocio,
    getMedioDePago,
    getSubCategoriaTransaccion,
    getTransaccionItemID,
    generarFacturaPDF,
    getUsuario,
    getTransaccionTransformedPresupuesto,
    getEntidadByID,
    getItemById,
    getItemUbicacionFilter,
    generarRemitoPDF,
    entidadesClientesTresLetras,
    getEntidadesClientesTresLetras,
    getTransaccionMontoTotalByTipoTransaccion,
    updateDeleteTransaccion,
    isNavbarCollapsed,
    getFechaHoraActualClient,
    getParametrosGlobales,
    getCanalEntidad,
    getTransaccionTransformedPresupuestosAllData,
    getTransaccionImpuestoItems,
  } = useContext(ErpContext)

  // Estados principales
  const [openModal, setOpenModal] = useState(false)
  const [transaccionItems, setTransaccionItems] = useState([])
  const [selectedTransaccionId, setSelectedTransaccionId] = useState(null)
  const [selectedTransaccion, setSelectedTransaccion] = useState(null)
  const [selectedTransaccionEntidad, setSelectedTransaccionEntidad] = useState(null)
  const [rows, setRows] = useState([])
  const [selectedUbicacion, setSelectedUbicacion] = useState(null)
  const today = dayjs();
  const [startDate, setStartDate] = useState(today.subtract(30, 'day'));
  const [endDate, setEndDate] = useState(today);
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(100)
  const [totalPages, setTotalPages] = useState(0)
  const [totalCount, setTotalCount] = useState(0)
  const [montoTotalTransacciones, setMontoTotalTransacciones] = useState(0)
  const [minVentas, setMinVentas] = useState(0)
  const [maxVentas, setMaxVentas] = useState(0)
  const [itemsMap, setItemsMap] = useState({})
  const [loading, setLoading] = useState(true)
  const [sortedData, setSortedData] = useState([])
  const [dniCliente, setDniCliente] = useState("")
  const [searchTextCliente, setSearchTextCliente] = useState("")
  const [filtersActive, setFiltersActive] = useState(false)
  const isFirstRender = useRef(true)
  const [mostrarDeletes, setMostrarDeletes] = useState(false)
  const [idTransaccionSearch , setIdTransaccionSearch] = useState(null)
  
  // Estados para canal de entidad
  const [canalesEntidades, setCanalesEntidades] = useState([])
  const [selectedCanalEntidad, setSelectedCanalEntidad] = useState(null)
  
  // Estados para gráficas
  const [openGraficasModal, setOpenGraficasModal] = useState(false)
  const [loadingGraficas, setLoadingGraficas] = useState(false)
  const [datosGraficas, setDatosGraficas] = useState([])
  
  // Estados para filtros adicionales
  const [masFiltrosActive, setMasFiltrosActive] = useState(false)
  

  // Funciones para manipular fechas
  // const deleteDate1 = () => setStartDate(null)
  // const deleteDate2 = () => setEndDate(null)
  const increaseDate = () => setStartDate((prev) => (prev ? prev.add(1, "day") : dayjs()))
  const decreaseDate = () => setStartDate((prev) => (prev ? prev.subtract(1, "day") : dayjs()))
  
  // Efectos ***************************************************************************************************************************************************************************************************
  // Efectos ***************************************************************************************************************************************************************************************************
  // Efectos ***************************************************************************************************************************************************************************************************
  // Efectos ***************************************************************************************************************************************************************************************************

  useEffect(() => {

    // console.log("first render after if")
    const today = dayjs()
    setStartDate(today.subtract(30, 'day'));
    setEndDate(today)
    fetchData(startDate, page, endDate, dniCliente, selectedUbicacion, minVentas, maxVentas, mostrarDeletes, idTransaccionSearch, selectedCanalEntidad)
    fetchDataInicio()
    setLoading(false)
  }, [])


  useEffect(() => {
    // console.log("efecto startdate")
    fetchData(startDate, page, endDate, dniCliente, selectedUbicacion, minVentas, maxVentas, mostrarDeletes, idTransaccionSearch, selectedCanalEntidad)
    setLoading(false)
  }, [startDate])


  useEffect(() => {
    // console.log("effect page")
    // setLoading(true)
    fetchData(startDate, page, endDate, dniCliente, selectedUbicacion, minVentas, maxVentas, mostrarDeletes, idTransaccionSearch, selectedCanalEntidad)
    setLoading(false)
  }, [page])

  // Verificar si hay filtros activos
  // useEffect(() => {
  //   // console.log("effect varios")
  //   const hasActiveFilters =
  //     (endDate && startDate && !endDate.isSame(startDate, "day")) ||
  //     dniCliente ||
  //     selectedUbicacion ||
  //     minVentas > 0 ||
  //     maxVentas > 0

  //   setFiltersActive(hasActiveFilters)
  //   setLoading(false)
  // }, [startDate, endDate, dniCliente, selectedUbicacion, minVentas, maxVentas])

  // Funciones para manejar filtros
  const buttonFiltrado = () => {
    fetchData(startDate, 1, endDate, dniCliente, selectedUbicacion, minVentas, maxVentas, mostrarDeletes, idTransaccionSearch, selectedCanalEntidad)  // cuando le doy al boton buscar tengo que ir a la pagina 1.
  }

  const fetchDataInicio = async () => {
    try {
      await getUbicacion()
      
      // Cargar canales de entidad si está habilitado
      const canalEntidad = await getParametrosGlobales(["canalEntidad"])
      console.log("canalEntidad canalEntidad :", canalEntidad.canalEntidad)
      if (canalEntidad.canalEntidad == 1) {
        const datosCanalesEntidades = await getCanalEntidad()
        console.log("datosCanalesEntidades:", datosCanalesEntidades)
        setCanalesEntidades(datosCanalesEntidades)
      }
    } catch (error) {
      console.error("Error al cargar ubicaciones:", error)
    }
  }

  const handleMinChange = (e) => {
    const newMin = Number(e.target.value)
    if (newMin <= maxVentas) {
      setMinVentas(newMin)
    }
  }

  const handleMaxChange = (e) => {
    const newMax = Number(e.target.value)
    if (newMax >= minVentas) {
      setMaxVentas(newMax)
    }
  }

  const fetchData = async (date, page, endDate, dniCliente, selectedUbicacion, valorMin, valorMax, mostrarDeletes, idTransaccionSearch, selectedCanalEntidad, limit = 100) => {    
    const controller = new AbortController()
    const signal = controller.signal
    try {
      
      setLoading(true)

      let validDate = date ? date : dayjs(); 
      let formattedDate = validDate.format("YYYY-MM-DD");
      // const formattedDate = await date.format("YYYY-MM-DD")
      let formattedDate2 = endDate
      let idDni = null
      let idSelectedUbicacion = null

      if (endDate && typeof endDate.format === "function") {
        formattedDate2 = endDate.format("YYYY-MM-DD")
      }
      if (dniCliente != null) {
        idDni = dniCliente.id
      }
      if (selectedUbicacion != null) {
        idSelectedUbicacion = selectedUbicacion.id
      }

const result1 = await getFechaHoraActualClient(formattedDate);
formattedDate = dayjs(result1.fechaServidor).startOf("day").toDate();

const result2 = await getFechaHoraActualClient(formattedDate2);
formattedDate2 = dayjs(result2.fechaServidor).endOf("day").toDate();

      const data = await getTransaccionTransformedPresupuesto(
        3,
        formattedDate,
        page,
        limit,
        { signal },
        formattedDate2,
        idDni,
        idSelectedUbicacion,
        valorMin,
        valorMax,
        mostrarDeletes,
        idTransaccionSearch,
        '',
        '',
        'todos',
        selectedCanalEntidad?.id || null
      )
      const transaccionTransformedVentas = data.data

      console.log("transaccionTransformedVentas: ", transaccionTransformedVentas)

      const transaccionTransformedReforged = transaccionTransformedVentas.map((transaccion) => {
        const pagos = transaccion.pagos.map((pago) => ({
          descripcion: pago.medioDePago,
          monto: pago.montoTotal,
        }))

        const formattedDate = new Intl.DateTimeFormat("es-AR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        }).format(new Date(transaccion.fechaHoraCreacion))

        return {
          id: transaccion.id,
          createdAt: formattedDate,
          montoTotal: transaccion.montoTotal,
          idMoneda: transaccion.pagos?.[0]?.cotizacion || "",
          idTipoTransaccion: transaccion.tipoTransaccion?.descripcion || "",
          pagos: pagos,
          descripcionEntidad: transaccion.entidad?.descripcion || "",
          dniCuitCuil: transaccion.entidad?.dniCuitCuil || "",
          apellido: transaccion.entidad?.apellido || "",
          direccion: transaccion.entidad?.direccion || "",
          localidad: transaccion.entidad?.localidad || "",
          provincia: transaccion.entidad?.provincia || "",
          usuario: transaccion.usuario?.usuario || "",
          negocio: transaccion.negocio?.descripcion || "",
          ubicacion: transaccion.ubicacion?.descripcion || "",
          idEntidadNumero: transaccion.idEntidad,
          fechaHoraCreacion: transaccion.fechaHoraCreacion,
          impuestos: transaccion.impuestos,
          montoDescuento: transaccion.montoDescuento,
          tipoFacturaDescripcion: transaccion.tipoFacturaDescripcion,
          porcentajeDescuento: transaccion.porcentajeDescuento,
        }
      })

      setPage(data.currentPage)
      setTotalPages(data.totalPages)
      setTotalCount(data.total)
      setMontoTotalTransacciones(data.totalMontoVentas)

      setSortedData(transaccionTransformedReforged)
    } catch (error) {
      console.error("Error al cargar los datos:", error)
    } finally {
      // console.log("finally")
      setLoading(false)
    }
  }

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("es-AR", {
      style: "currency",
      currency: "ARS",
    }).format(value)
  }

  useEffect(() => {
    if (searchTextCliente.length >= 3) {
      getEntidadesClientesTresLetras(searchTextCliente, 1)
      setLoading(false)
    }
    
  }, [searchTextCliente])

  useEffect(() => {
    // console.log("effect ti gi")
    const fetchItemsDetails = async () => {
      const itemsDetails = {}

      await Promise.all(
        transaccionItems.map(async (transaccionItem) => {
          const foundItem = await getItemById(transaccionItem.idItem)
          if (foundItem) {
            itemsDetails[transaccionItem.idItem] = foundItem
          }
        }),
      )

      setItemsMap(itemsDetails)
    }

    fetchItemsDetails()
    setLoading(false)
  }, [transaccionItems, getItemById])

  const columns = [
    { field: "id", headerName: "ID", flex: 0.3, minWidth: 70, headerAlign: "center", renderCell: (params) => (
      <Box sx={{ display: "flex", justifyContent: "flex-start", gap: 1 }}>
        <Typography variant="body2">{params.value}</Typography>
      </Box>
    ), },    {
      field: "createdAt",
      headerName: "Fecha",
      flex: 1,
      minWidth: 200,
      headerAlign: "center",
      renderCell: (params) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <CalendarTodayIcon fontSize="small" sx={{ color: alpha("#5b5b5f", 0.7) }} />
          <Typography variant="body2">{params.value}</Typography>
        </Box>
      ),
    },
    {
      field: "montoTotal",
      headerName: "Monto",
      type: "number",
      headerAlign: "center",
      flex: 0.8,
      minWidth: 130,
      renderCell: (params) => (
        <Chip
          icon={<AttachMoneyIcon fontSize="small" />}
          label={params.value?.toLocaleString("es-AR") || "0.00"}
          size="small"
          sx={{
            fontWeight: "bold",
            bgcolor: alpha("#4CAF50", 0.1),
            color: "#4CAF50",
            "& .MuiChip-icon": { color: "#4CAF50" },
            display: "flex",
          }}
        />
      ),
    },
    {
      field: "descripcionEntidad",
      headerName: "Cliente",
      headerAlign: "center",
      flex: 1.2,
      minWidth: 150,      
      renderCell: (params) => (
        <Tooltip title={`${params.row.descripcionEntidad} ${params.row.apellido || ""}`}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <PersonIcon fontSize="small" sx={{ color: alpha("#5b5b5f", 0.7),}} />
            <Typography variant="body2" noWrap fontWeight={'500'}>
              {params.row.descripcionEntidad} {params.row.apellido || ""}
            </Typography>
          </Box>
        </Tooltip>
      ),
    },
    {
      field: "usuario",
      headerName: "Vendedor",
      headerAlign: "center",
      flex: 0.8,
      minWidth: 150,
      renderCell: (params) => (
        <Typography variant="body2" sx={{ fontStyle: "italic" }}>
          {params.value}
        </Typography>
      ),
    },
    {
      field: "ubicacion",
      headerName: "Ubicación",
      headerAlign: "center",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <LocationOnIcon fontSize="small" sx={{ color: alpha("#5b5b5f", 0.7) }} />
          <Typography variant="body2">{params.value}</Typography>
        </Box>
      ),
    },
    {
      field: "action",
      headerName: "Acciones",
      headerAlign: "center",
      width: 150,
      renderCell: (params) => (
        <Box sx={{ display: "flex", gap: 0.5 }}>
          <Tooltip title="Ver detalles">
            <IconButton
              className="colorGeneralParaIconos"
              onClick={() => handleOpenModal(params.row)}
              size="small"
              sx={{
                bgcolor: alpha("#5b5b5f", 0.1),
                "&:hover": { bgcolor: alpha("#5b5b5f", 0.2) },
              }}
            >
              <VisibilityIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Descargar PDF">
            <IconButton
              className="colorGeneralParaIconos"
              onClick={() => handleDownloadPDF(params.row)}
              size="small"
              sx={{
                bgcolor: alpha("rgb(244, 177, 14)", 0.1),
                "&:hover": { bgcolor: alpha("rgb(244, 177, 14)", 0.2) },
              }}
            >
              <PictureAsPdfIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Borrar Transaccion">
            <IconButton
              className="colorGeneralParaIconos"
              onClick={() => borrarTransaccion(params.row)}
              size="small"
              sx={{
                bgcolor: alpha("rgb(244, 177, 14)", 0.1),
                "&:hover": { bgcolor: alpha("rgb(244, 177, 14)", 0.2) },
              }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ]

  const totalVentas = useMemo(() => rows.reduce((acc, row) => acc + (row.montoTotal || 0), 0), [rows])

  const CustomFooter = () => (
    <GridFooterContainer>
      <div
        style={{
          padding: "10px",
          fontWeight: "bold",
          fontSize: "16px",
          textAlign: "right",
          width: "100%",
          backgroundColor: "#f5f5f5",
        }}
      >
        Total Ventas: <span style={{ color: "#4CAF50" }}>${totalVentas.toLocaleString("es-AR")}</span>
      </div>
      <GridFooter />
    </GridFooterContainer>
  )

const borrarTransaccion = async (transaccionRow) => {
  
    const result = await Swal.fire({
      title: "¿Estás seguro?",
      text: `Vas a eliminar la transacción con ID ${transaccionRow.id}. Esta acción no se puede deshacer.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    })
  
    if (result.isConfirmed) {
      try {
        // ejecuta la eliminación
        await updateDeleteTransaccion(transaccionRow.id)
  
        // refresca los datos (ajusta los args a tu fetchData)
        await fetchData(startDate, page, endDate, dniCliente, selectedUbicacion, minVentas, maxVentas, mostrarDeletes, idTransaccionSearch)

  
        Swal.fire({
          title: "Eliminado",
          text: `La transacción ${transaccionRow.id} ha sido eliminada.`,
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        })
      } catch (error) {
        console.error("Error al borrar transacción:", error)
        Swal.fire({
          title: "Error",
          text: "No se pudo eliminar la transacción. Intenta de nuevo.",
          icon: "error",
        })
      }
    }
  }

  const handleDownloadPDF = async (transaccionRow) => {
    try {
      setLoading(true)
      console.log("transaccionRow: ", transaccionRow)
      const transaccionEncontrada = await getTransaccionItemID(transaccionRow.id)
      const entidadCliente = await getEntidadByID(transaccionRow.idEntidadNumero)

      const itemsTransaccion = await Promise.all(
        transaccionEncontrada.map(async (transItem) => {
          const foundItem = await getItemById(transItem.idItem)

          const precio = transItem?.precio || 0

          return {
            idItem: transItem.idItem,
            codigo: foundItem ? foundItem.codigo : "N/A",
            descripcion: foundItem ? foundItem.descripcion : "Descripción no disponible",
            cantidad: transItem.cantidad || 0,
            precio: precio,
            porcentajeDescuento: transItem.porcentajeDescuento || 0,
            total: (precio * transItem.cantidad).toFixed(2),
          }
        }),
      )

      generarFacturaPDF(transaccionRow, itemsTransaccion, entidadCliente, "presupuesto", transaccionRow.impuestos, "presupuesto")
    } catch (error) {
      console.error("Error al generar PDF:", error)
    } finally {
      // console.log("finally")
      setLoading(false)
    }
  }


  const handleDownloadRemito = async (transaccionRow) => {
    try {
      setLoading(true)
      const transaccionEncontrada = await getTransaccionItemID(transaccionRow.id)
      const entidadCliente = await getEntidadByID(transaccionRow.idEntidadNumero)

      const itemsTransaccion = await Promise.all(
        transaccionEncontrada.map(async (transItem) => {
          const foundItem = await getItemById(transItem.idItem)
          const foundItemUbicacion = foundItem ? await getItemUbicacionFilter(foundItem.id) : null

          const precio = foundItemUbicacion[0]?.precio || 0

          return {
            codigo: foundItem ? foundItem.codigo : "N/A",
            descripcion: foundItem ? foundItem.descripcion : "Descripción no disponible",
            cantidad: transItem.cantidad || 0,
            precio: precio,
            porcentajeDescuento: transItem.porcentajeDescuento || 0,
            total: (precio * transItem.cantidad).toFixed(2),
          }
        }),
      )

      generarRemitoPDF(
        transaccionRow,
        itemsTransaccion,
        entidadCliente,
        transaccionRow.usuario,
        "tablaVenta",
        transaccionRow.impuestos,
      )
    } catch (error) {
      console.error("Error al generar remito:", error)
    } finally {
      // console.log("finally")
      setLoading(false)
    }
  }

  const [calculatedTotal, setCalculatedTotal] = useState(null)
  const [totalMontoDescuento, setTotalMontoDescuento] = useState(null)
  const [totalPorcentajeDescuento, setPorcentajeDescuento] = useState(null)
  const [montoSinImpuesto, setMontoSinImpuesto] = useState(null)

  const handleOpenModal = async (transaccionRow) => {
    try {
      setLoading(true)
      setSelectedTransaccion(transaccionRow)
      const entidadCliente = await getEntidadByID(transaccionRow.idEntidadNumero)
      setSelectedTransaccionEntidad(entidadCliente)

      const items = await getTransaccionItemID(transaccionRow.id)
      
      // Obtener impuestos de los items de la transacción
      try {
        const impuestosItems = await getTransaccionImpuestoItems(transaccionRow.id)
        console.log("Impuestos de items obtenidos:", impuestosItems)
        
        if (impuestosItems && impuestosItems.length > 0) {
          // Crear mapa de impuestos por item
          const impuestosMap = {}
          impuestosItems.forEach(impuesto => {
            impuestosMap[impuesto.idItem] = {
              idImpuesto: impuesto.idImpuesto,
              porcentaje: impuesto.porcentaje,
              descripcionImpuesto: impuesto.descripcionImpuesto
            }
          })
          
          // Concatenar información de impuestos a los items
          const itemsConImpuestos = items.map(item => ({
            ...item,
            impuestoData: impuestosMap[item.idItem] || null
          }))
          
          setTransaccionItems(itemsConImpuestos)
        } else {
          // Si no hay impuestos, usar items sin modificar
          setTransaccionItems(items)
        }
      } catch (error) {
        console.log("No se encontraron impuestos para esta transacción:", error)
        // Si hay error, usar items sin modificar
        setTransaccionItems(items)
      }

      const { montoTotal, impuestos = [], montoDescuento = 0, porcentajeDescuento = 0 } = transaccionRow

      const totalSinImpuestos = impuestos.reduce((total, impuesto) => total - (impuesto.montoTotal || 0), montoTotal)

      const totalSinImpuestosYDescuento = totalSinImpuestos + montoDescuento
      const totalFinal = totalSinImpuestosYDescuento * (1 - porcentajeDescuento / 100)

      setCalculatedTotal(totalFinal)
      setTotalMontoDescuento(montoDescuento)
      setPorcentajeDescuento(porcentajeDescuento)
      setMontoSinImpuesto(totalSinImpuestos)

      setOpenModal(true)
    } catch (error) {
      console.error("Error al abrir modal:", error)
    } finally {
      // console.log("finally")
      setLoading(false)
    }
  }

  const handleCloseModal = () => {
    setOpenModal(false)
  }

  // Función para abrir modal de gráficas
  const handleOpenGraficasModal = async () => {
    try {
      setLoadingGraficas(true)
      setOpenGraficasModal(true)
      
      // Llamar a la función sin paginado para obtener todos los datos
      const result = await getTransaccionTransformedPresupuestosAllData(
        3, // Tipo de transacción para presupuestos
        startDate ? dayjs(startDate).startOf("day").toDate() : dayjs().startOf("day").toDate(),
        endDate ? dayjs(endDate).endOf("day").toDate() : dayjs().endOf("day").toDate(),
        dniCliente?.id || "",
        selectedUbicacion?.id || "",
        minVentas || "",
        maxVentas || "",
        mostrarDeletes,
        idTransaccionSearch || "",
        "",
        "",
        "todos",
        selectedCanalEntidad?.id || null
      )
      
      setDatosGraficas(result.data)
    } catch (error) {
      console.error("Error al obtener datos para gráficas:", error)
    } finally {
      setLoadingGraficas(false)
    }
  }

  const handleCloseGraficasModal = () => {
    setOpenGraficasModal(false)
    setDatosGraficas([])
  }

  const resetFilters = () => {
    // console.log("resetFilters")
    setDniCliente(null)
    setSelectedUbicacion(null)
    setSearchTextCliente("")
    setMinVentas(0)
    setMaxVentas(0)
    setMostrarDeletes(false)
    setIdTransaccionSearch('')
    setSelectedCanalEntidad(null)

    // Mantener solo la fecha de inicio como hoy
    const today = dayjs()
    setStartDate(today.subtract(30, 'day'));
    setEndDate(today)

    // Refrescar datos con filtros reseteados
    fetchData(startDate, 1, endDate, null, null, 0, 0, false, null, null) 
  }

  // Renderiza el spinner mientras está cargando - Usando la lógica original
  if (loading) {
    return <SpinnerLading />
  }

// ************************************************************************************************************************************************************
// ************************************************************************************************************************************************************
// ************************************************************************************************************************************************************
// ************************************************************************************************************************************************************
// ************************************************************************************************************************************************************
// ************************************************************************************************************************************************************
// html:

  return (
    <div
      className="tablaVentasContainer"
      style={{ display: "flex", flexDirection: "column", height: "100%", width: "100%", overflow: "hidden", position: "relative", }}
    >
      <ThemeProvider theme={theme}>
        {/* Contenedor de filtros - Ahora en una sola fila compacta */}
        <Paper
  className="diseñoFiltroTransaccionesVenta"
  elevation={3}
  sx={{
    p: 2,
    mb: 2,
    borderRadius: 2,
    backgroundColor: alpha(theme.palette.background.paper, 0.9),
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",    
  }}
>
  <Box
    sx={{
      display: "flex",
      flexWrap: "wrap",
      gap: 2,
      alignItems: "center",
      justifyContent: "space-between",
    }}
  >
    {/* Filtro de fechas */}
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, flex: 1, minWidth: 250 }}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <IconButton onClick={decreaseDate} color="primary" size="small">
          <ArrowBackIcon fontSize="small" />
        </IconButton>
        <DatePicker
          value={startDate}
          onChange={(newValue) => setStartDate(newValue)}
          format="DD/MM/YYYY"
          label="Desde"
          slotProps={{
            textField: { size: "small", inputProps: { maxLength: 10 } },
          }}
          sx={{ width: 150 }}
        />
        <DatePicker
          value={endDate}
          onChange={(newValue) => setEndDate(newValue)}
          format="DD/MM/YYYY"
          label="Hasta"
          slotProps={{
            textField: { size: "small", inputProps: { maxLength: 10 } },
          }}
          sx={{ width: 150 }}
        />
        <IconButton onClick={increaseDate} color="primary" size="small">
          <ArrowForwardIcon fontSize="small" />
        </IconButton>
      </LocalizationProvider>
    </Box>

    {/* Filtro de montos */}
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: 'center', gap: 1, flex: 1, minWidth: 200 }}>
      <TextField
        label="Mínimo"
        type="number"
        size="small"
        value={minVentas}
        onChange={handleMinChange}
        InputProps={{
          startAdornment: <InputAdornment position="start">$</InputAdornment>,
        }}
        sx={{ width: 150 }}
      />
      <TextField
        label="Máximo"
        type="number"
        size="small"
        value={maxVentas}
        onChange={handleMaxChange}
        InputProps={{
          startAdornment: <InputAdornment position="start">$</InputAdornment>,
        }}
        sx={{ width: 150 }}
      />
    </Box>

    {/* Filtro de cliente y ubicación */}
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, flex: 2, minWidth: 300 }}>
         <TextField
        label="Buscar por ID"
        type="number"
        size="small"
        value={idTransaccionSearch}
        onChange={e => setIdTransaccionSearch(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
        sx={{ width: '20%' }}
      />
      <Autocomplete
        size="small"
        disablePortal
        options={entidadesClientesTresLetras.map((it) => ({
          label: `${it.descripcion} - ${it.apellido} - ${it.dniCuitCuil}`,
          ...it,
        }))}
        value={dniCliente}
        onChange={(event, newValue) => setDniCliente(newValue || null)}
        onInputChange={(event, newInputValue) => setSearchTextCliente(newInputValue)}
        sx={{ flex: 1 }}
        renderInput={(params) => <TextField {...params} label="Cliente" variant="outlined" />}
      />
      <Autocomplete
        size="small"
        disablePortal
        options={ubicaciones.map((it) => ({
          id: it.id,
          label: it.descripcion,
        }))}
        value={selectedUbicacion}
        onChange={(event, newValue) => setSelectedUbicacion(newValue)}
        sx={{ flex: 1 }}
        renderInput={(params) => <TextField {...params} label="Ubicación" variant="outlined" />}
      />
      {/* CheckBox para mostrar eliminados */}
  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
    <Typography variant="body2">Mostrar eliminados</Typography>
    <Checkbox
       checked={mostrarDeletes}
       onChange={(e) => setMostrarDeletes(e.target.checked)}
       color="primary"
    />
  </Box>
    </Box>

    {/* Botones de acción */}
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Button
        variant="contained"
        size="small"
        onClick={buttonFiltrado}
        startIcon={<SearchIcon />}
        sx={{
          backgroundColor: "#5b5b5f",
          textTransform: "none",
          padding: "8px 16px",
          color: "white",
          "&:hover": {
            backgroundColor: alpha("rgb(244, 177, 14)", 0.8),
          },
        }}
      >
        Buscar
      </Button>
      {/* Botón de Gráficas */}
      <Button
        variant="outlined"
        size="small"
        onClick={handleOpenGraficasModal}
        startIcon={<BarChartIcon />}
        disabled={loading}
        sx={{
          textTransform: "none",
          borderColor: "#4caf50",
          color: "#4caf50",
          "&:hover": {
            backgroundColor: alpha("#4caf50", 0.1),
            borderColor: "#4caf50",
          },
        }}
      >
        Mostrar Gráficas
      </Button>

      {/* Botón Mostrar Más Filtros */}
      <Button
        variant="text"
        size="small"
        onClick={() => setMasFiltrosActive(!masFiltrosActive)}
        startIcon={<TuneIcon />}
        sx={{
          textTransform: "none",
          color: "#666",
          "&:hover": {
            backgroundColor: alpha("#666", 0.1),
          },
        }}
      >
        {masFiltrosActive ? "Ocultar Filtros" : "Mostrar Más Filtros"}
      </Button>

      <Tooltip title={filtersActive ? "Resetear filtros" : "Refrescar"}>
        <IconButton
          onClick={resetFilters}
          color="primary"
          size="small"
          sx={{
            bgcolor: filtersActive ? alpha(theme.palette.secondary.main, 0.1) : "transparent",
            "&:hover": { bgcolor: alpha(theme.palette.secondary.main, 0.2) },
          }}
        >
          {filtersActive ? <FilterAltOffIcon /> : <ReplayIcon />}
        </IconButton>
      </Tooltip>
    </Box>
  </Box>
</Paper>

        {/* Sección de Filtros Adicionales */}
        {masFiltrosActive && (
          <Paper
            sx={{
              p: 2,
              m: 1,
              borderRadius: 3,
              boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)",
              bgcolor: "grey.50",
            }}
          >
            <Typography variant="body2" sx={{ mb: 2, fontWeight: 600, color: "text.secondary" }}>
              Filtros adicionales
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                alignItems: "flex-start",
                gap: 2,
              }}
            >
              {canalesEntidades && canalesEntidades.length > 0 && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    flex: 1,
                    minWidth: { xs: "100%", md: 300 },
                  }}
                >
                  <Typography variant="body2" sx={{ minWidth: 120 }}>
                    Canal de entidad:
                  </Typography>
                  <Autocomplete
                    size="small"
                    disablePortal
                    options={[
                      { id: null, label: "Todos los canales" },
                      ...canalesEntidades.map((canal) => ({
                        id: canal.id,
                        label: canal.descripcion || `Canal ${canal.id}`,
                      })),
                    ]}
                    value={
                      selectedCanalEntidad
                        ? {
                            id: selectedCanalEntidad.id,
                            label: selectedCanalEntidad.label,
                          }
                        : { id: null, label: "Todos los canales" }
                    }
                    onChange={(event, newValue) => setSelectedCanalEntidad(newValue?.id ? newValue : null)}
                    sx={{ flex: 1, minWidth: 150 }}
                    renderInput={(params) => <TextField {...params} label="Seleccionar canal" variant="outlined" />}
                  />
                </Box>
              )}
            </Box>
          </Paper>
        )}

        {/* Contenedor de la tabla (scrollable) */}
        <Paper
          sx={{
            flex: 1,
            m: 1,
            borderRadius: 3,
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            position: "relative",
            height: "500px", 
          }}
        >
          <DataGrid
key={isNavbarCollapsed ? "collapsed" : "expanded"}
            className="tablaVentasDataGrid"
            rows={sortedData}
            columns={columns}
            getRowId={(row) => row.id}
            rowCount={totalPages * 100}
            pagination
            getRowHeight={() => 35}
            headerHeight={35}         
            paginationMode="server"
            sx={{
              width: "100%",
              border: 0,
              "& .MuiDataGrid-footerContainer": {
                display: "none !important",
              },
              "& .MuiDataGrid-columnHeaders": { //MANEJA CSS HEADER
                backgroundColor: "#5b5b5f",
                color: "white",
                borderBottom: "2px solid #333",
                height: "45px !important",
                minHeight: "45px !important",
                maxHeight: "45px !important",
              },
              "& .MuiDataGrid-columnHeader": { //MANEJA CSS HEADER
                height: "45px !important",
                minHeight:       "45px !important",
                maxHeight: "45px !important",
              },
              "& .MuiDataGrid-columnHeaderTitle": { //MANEJA CSS HEADER
                color: "white !important",
                lineHeight: "45px !important",
              },
              "& .MuiDataGrid-columnHeaderTitle .MuiDataGrid-menuIconButton": {
                color: "white !important",
              },
              "& .MuiDataGrid-menuIconButton": {
                color: "rgb(244, 177, 14) !important",
              },
              "& .MuiInputBase-root": {
                color: "rgb(244, 177, 14) !important",
              },
              "& .MuiTablePagination-root": {
                color: "black !important",
              },
              "& .MuiSelect-icon": {
                color: "rgb(244, 177, 14) !important",
              },
              "& .MuiDataGrid-cell": {
                borderBottom: "1px solid #ccc",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              },
              "& .MuiDataGrid-row": {
                
                "&:nth-of-type(even)": {
                  backgroundColor: "#F7F7F7",
                },
                "&:hover": {
                  backgroundColor: "#E3EAFD",
                  transition: "background 0.3s ease",
                },
              },
              "& .row-devolucion": {
                backgroundColor: alpha("#9e9e9e !important", 0.05),
                "&:hover": {
                  backgroundColor: alpha("#9e9e9e !important", 0.1),
                },
              },
              "& .MuiDataGrid-virtualScroller": {
                lineHeight: "none !important",
                height: "10px !imporant",
              },
              "& .MuiDataGrid-footerContainer": {
                position: "sticky",
                bottom: 0,
                backgroundColor: "#ffffff",
                borderTop: "1px solid #ddd",
                zIndex: 10,
              },
              "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
                width: "2px",
              },
              "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb": {
                backgroundColor: "#888",
                borderRadius: "10px",
              },
            }}
            components={{
              Pagination: () => null,
            }}
          />
        </Paper>

        {/* Contenedor del footer (paginación) */}
        <Box sx={{ flexShrink: 0, p: 1 }}>
          <CustomPagination
            currentPage={page}
            totalPages={totalPages}
            totalCount={totalCount}
            montoTotalTransacciones={montoTotalTransacciones}
            vieneDe={"tablaVentas"}
            onPageChange={(newPage) => setPage(newPage)}
          />
        </Box>

        {/* Modal */}
        <ModalViewTablaPresupuesto
          openModal={openModal}
          handleCloseModal={handleCloseModal}
          selectedTransaccion={selectedTransaccion}
          selectedTransaccionEntidad={selectedTransaccionEntidad}
          transaccionItems={transaccionItems}
        />

        {/* Modal de Gráficas */}
        <GraficasPresupuestosModal
          open={openGraficasModal}
          handleClose={handleCloseGraficasModal}
          data={datosGraficas}
          loading={loadingGraficas}
        />
      </ThemeProvider>
    </div>
  )
}

